import axios from 'axios'
import useSWR, { Fetcher } from 'swr'
import { GetVehiclesResponse } from '@retail-common/util-search-response-types'
import { getVehiclesUrlForSearchParams } from './utils/get-vehicles-url-for-search-params'
import { SearchVehiclesApiParams } from './types'

const httpClient = axios.create()

const fetcher: Fetcher<GetVehiclesResponse, string> = async (url) =>
  httpClient
    .get(url, {
      headers: {
        'x-search-api-consumer': 'vehicles-hook',
      },
    })
    .then((res) => res.data)

/**
 * Get vehicles from the search API using the useSWR hook
 * @param searchServiceUrl base URL for the search API. Get this from Env.SearchServiceUrl
 * @param params search parameters to apply in the request (filters or other parameters)
 * @param channelId channelId to get vehicles from. Defaults to `cinch`
 */
export const useSearchVehicles = (
  searchServiceUrl: string,
  searchParams?: Partial<SearchVehiclesApiParams>,
  channelId?: string,
) => {
  const requestUrl = getVehiclesUrlForSearchParams(
    searchServiceUrl,
    searchParams,
    channelId,
  )

  const { isValidating, isLoading, data, error } = useSWR(requestUrl, fetcher)

  return {
    isValidating,
    isLoading,
    searchResults: data,
    vehiclesApiError: error,
  }
}
